<template>
  <router-view />
</template>

<script>
import { useStore } from "vuex";
import { onMounted } from "@vue/runtime-core";

export default {
  setup() {
    onMounted(async () => {
      const store = useStore();

      // auto-login
      const tokenString = localStorage.getItem("token");

      if (tokenString) {
        const token = JSON.parse(tokenString);
        store.commit("SET_TOKEN_DATA", token);
      }

      document.title = "Cloud Droplet";
    });
  },
};
</script>

<style>
body {
  margin: 0 auto;
  min-height: 100vh;
  background-color: rgb(255, 255, 255);
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
}
</style>
